var styles = {"tabPanel":"styles_tab-panel__4DNmb","hide":"styles_hide__kPTw3"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
